import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhyARevocableLivingTrustCanAffectAMedicaidSpendDownPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-why-a-revocable-living-trust-can-affect-a-medicaid-spend-down/']} />;
}
